import React, {Dispatch, useCallback, useContext, useEffect, useMemo, useRef, useState} from "react";
import { useTranslation } from "react-i18next";
import {Form} from "react-bootstrap";
import {Button, CircularProgress, Grid, Typography} from "@material-ui/core";
import MuiLink from "@material-ui/core/Link";

import OnBoardingApis from "../../../apis/onboarding.apis";
import background_image from "../../../assets/images/signup_background.svg";
import shapes_and_masked_images from "../../../assets/images/shapes_and_masked_images.png";
import {Formik} from "formik";
import * as yup from "yup";
import {AppDispatchContext, AppStateContext, NotificationContext} from "../../../App";
import {Link as RouterLink, useHistory, useLocation, useParams} from "react-router-dom";
import qs from "qs";
import useIsMounted from "ismounted";
import {HandleErrors} from "../../../components/helper/form.helper";
import {iStoreAction} from "../../../redux/reducers";
import {createStyles, makeStyles, Theme} from "@material-ui/core/styles";
import Hidden from "@material-ui/core/Hidden";
import rectangle_background from "../../../assets/images/Rectangle.png";
import {animated, Transition} from "react-spring/renderprops";
import {Scrollbar} from "../../../components/CustomScroll/ScrollBars";
import Box from "@material-ui/core/Box";
import {ArrowForward} from "@material-ui/icons";
import Alert from "@material-ui/lab/Alert";
import UserAPIs from "../../../apis/user.apis";
import DashboardLayer from "../../../components/Onboarding/Layer.main";
import LeftBorderInputFormik from "../../../components/LeftBorderInputFormik";
import LeftBorderSelect from "../../../components/LeftBorderSelect";
import RegisterConnectOptions from "./RegisterConnectOptions";
import "./register-connect-mobile.scss";


export const RegisterPageStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: { width: '100%', 
            display:'none'
        },
        registerArea: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            backgroundSize: "cover",
            position: "absolute",
            top: "0px",
            left: "0px",
            width: "100%",
            height: "100%",
            overflowY: "scroll",
            overflowX: "scroll",
            padding: theme.spacing(2)
        },

        registerCard: {
            height: "638px",
            width: "900px",
            backgroundColor: "#fff",
            boxShadow: "var(--box-shadow-large)",
            border: 0,
            borderRadius: "10px",
            display: "flex",
            [theme.breakpoints.down('sm')]: {
                width: "98vw",
            },
        },

        previewCard: {
            width: '400px',
            marginLeft: '20px',
            padding: '20px'
        },

        internalDiv: {
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between'
        },

        topDiv: {
            marginTop: '20px',
            textAlign: 'center'
        },

        nameTxt: {
            fontSize: '25px',
            fontWeight: 700
        },

        mt4: {
            marginTop: '4px'
        },

        m1: {
          marginLeft: '1rem'  
        },

        px20: {
            paddingLeft: '20px',
            paddingRight: '20px',
            marginTop: '40px'
        },

        flex: {
            display: 'flex',
            marginTop: '8px'
        },

        registerCardSideBar: {
            flex: 1
        },
        loginWelcomeText: {
    fontFamily: "Syne",
    fontWeight: 500,
    letterSpacing: '-0.03em',
            fontSize: "30px",
            textAlign: "left"

        },
        joinHeading: {
            fontSize: 22,
            fontFamily: "Syne",
            fontWeight: 500,
            letterSpacing: "-0.03em",
            fontKerning: "none",
            lineHeight: 1.25,
            textAlign: "left",
            color: "#111",
            margin: 0,
            whiteSpace: "nowrap",
            [theme.breakpoints.down("sm")]: {
                fontSize: 17,
                whiteSpace: "normal",
            },
        },
        loginWelcomeText1: {
            fontWeight: "normal",
            fontSize: "24px",
            textAlign: "left"

        },
        registerCardMainContent: {
            flex: 2,
        },
        registerCardSideBarItem: {
            borderTopRightRadius: "10px",
            borderBottomRightRadius: "10px",
            height: "600px",
            position: "relative"
        },
        registerCardSideBarItemTypo: {
            fontSize: "18px",
            color: "white",
            width: "100%",
            fontWeight: 200,
            textAlign: "center",
            padding: theme.spacing(1)
        },
        loginFormGroup: {
            width: "100%",
            maxWidth: "100%",
            "& input": {
                width: "100%",
                maxWidth: "100%",
                boxSizing: "border-box",
            },
        },
        gettingStartedButton: {
            backgroundColor: "black",
            color: "white",
            makeStyles: "70px"
        },
                registerCardNew: {
            paddingBottom: "20px",
            borderRadius: "10px",
            display: "flex",
            flexFlow: "column",
            rowGap: 10,
            gap: 10,
            width: "100%",
            maxWidth: "100%",
            boxSizing: "border-box",
        },
        registerCardChild: {
            display: "flex",
            flexFlow: "column",
            rowGap: 10,
            gap: 10,
            width: "100%",
            maxWidth: "100%",
            boxSizing: "border-box",
        },
        submit: {
            padding: 12,
            fontFamily: "Syne !important",
            fontSize: 16,
            boxShadow: "none",
            margin: theme.spacing(2, 0, 0),
            width: "100%",
            maxWidth: "100%",
            boxSizing: "border-box",
            backgroundColor: "#0f172a",
            color: "#ffffff",
            "&:hover": {
                backgroundColor: "#020617",
            },
        },

    },), {index: 1},
);


function RegisterHome() {
    const { t } = useTranslation("auth");
    const [shopPlatform, setShopPlatform] = useState<string>("");
    const urlRegisterSchema = useMemo(
        () =>
            yup.object({
                website_url: yup
                    .string()
                    .matches(
                        /((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/,
                        t("register.home.validation.urlFormat")
                    )
                    .required(t("register.home.validation.urlRequired")),
            }),
        [t]
    );
    useEffect(() => {
        document.title = t("register.documentTitle");
    }, [t]);
    const classes = RegisterPageStyles();
    const dispatch: Dispatch<iStoreAction> = useContext(AppDispatchContext);
    const [defaultURL, setDefaultUrl] = useState<string>("");
    const history = useHistory();
    const [loading, setLoading] = useState<boolean>(true);
    const params: any = useParams();
    const [error, setError] = useState<string | undefined>();
    const isMounted = useIsMounted();
    const notificationContext = useContext(NotificationContext);
    const formikRef = useRef<any>();
    const location = useLocation();
    const [touchedCustom, setTouchedCustom] = useState<boolean>(false);

    useEffect(() => {
        const params = qs.parse(location.search, {ignoreQueryPrefix: true});
        if (params.af_id) {
            // @ts-ignore
            new OnBoardingApis().users_aff(params.af_id).then(res => {

            })
        }

    }, [])

    useEffect(() => {
        document.body.classList.add("login_body");

        const rootDiv = document.querySelector('#root') as HTMLElement;
        
        if (rootDiv) {
          rootDiv.style.width = '100%';
        }
    

        return () => {
            document.body.classList.remove("login_body");
            document.body.classList.add("site_body");
        };
    }, []);


    const register = useCallback(() => {
        new OnBoardingApis().register_form(defaultURL,"shopify", "", "", "")
            .then((r) => {
                if (isMounted.current) {
                    if (OnBoardingApis.hasError(r, notificationContext) || (!r.redirectURL && !r.shop && !r.reactURL)) {
                        setLoading(false);
                        setError(r.message);
                    } else if (r.shop) {
                        dispatch({
                            type: "set_active_shop",
                            shop: r.shop
                        })
                        history.push({pathname: "/"});
                    } else if (r.redirectURL) {
                        window.location.href = r.redirectURL;
                    } else if (r.reactURL) {
                        history.replace(r.reactURL);
                    }
                }
            });
    }, [defaultURL, isMounted])

    useEffect(() => {
        const params = qs.parse(location.search, {ignoreQueryPrefix: true});
        if (params && params.shop && typeof params.shop === "string") {
            setDefaultUrl(params.shop)
            setLoading(true);
        } else {
            setLoading(false);
        }
    }, [])
    useEffect(() => {
        if (defaultURL) {
            register();
        }
    }, [defaultURL])

    const {loggedInUser} = useContext(AppStateContext);

    if (loading) {
        return null;
    }

    return <>
    <DashboardLayer>
        <Grid container justifyContent="center">
            {/* {
                loggedInUser && <Grid
                    item
                    xs={12}
                    container
                >
                    {
                        error && <Grid item xs={12}>
                            <div>
                                <Alert severity="error" color="error">
                                    {error}
                                </Alert>
                            </div>
                        </Grid>
                    }
                    <Grid item xs={12}>
                        <div>
                            <Typography className={classes.loginWelcomeText1}>
                                Install Emailwish app from Shopify Marketplace.
                            </Typography>
                        </div>
                    </Grid>
                    <Grid item className="mt-2">
                        <a href="https://apps.shopify.com/emailmarketing_emailwish_abandonedcart_popup_chat_reviews"
                        > <Button variant="contained" color="primary"
                                className="positive-button">
                            Install Now <ArrowForward/>
                        </Button>
                        </a>
                    </Grid>
                    <Grid item>
                        <Grid container spacing={1} className="mt-2">
                            <Grid item>
                                <Typography>
                                    Please remain logged in with Emailwish and we will add the new
                                    shop
                                    to
                                    your account automatically.<br/>
                                    Logged in as : {loggedInUser.email}<br/><br/>
                                    <span>
                                        Don't want to use this account? <a onClick={() => {
                                        new UserAPIs().logout().then(() => {
                                            if (isMounted.current) {
                                                dispatch({type: "logout"});
                                                history.replace("/login");
                                            }
                                        });
                                    }} className="app-link">Logout now</a>
                                    </span>
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} className="mt-4">
                        <div>
                            <Typography className={classes.loginWelcomeText1}>
                                Install Emailwish app For Woocommerce.
                            </Typography>
                        </div>
                    </Grid>
                    <Grid item className="mt-2">
                        <a href="https://wordpress.org/plugins/emailwish/"
                        > <Button variant="contained" color="primary"
                                className="positive-button">
                            Download Now <ArrowForward/>
                        </Button>
                        </a>
                    </Grid>
                </Grid>
            } */}
            {/* {
                loggedInUser &&  */}
                <Grid
                    item
                    xs={12}
                    container
                >
                    {
                        error && <Grid item xs={12}>
                            <div>
                                <Alert severity="error" color="error">
                                    {error}
                                </Alert>
                            </div>
                        </Grid>
                    }
                    <Grid item xs={12} className={classes.registerCardNew}>

                        <div>
                            <Typography component="h1" variant="h3" className={classes.joinHeading}>
                                {t("register.home.joinTitle")}
                            </Typography>
                        </div>

                    </Grid>
                    <Grid item xs={12}>
                        <Typography>
                            {t("register.home.subtitle")}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} className="register-connect-platform-field">
                        <p className="register-connect__prompt">
                            {t("register.home.platform.prompt")}
                        </p>
                        <LeftBorderSelect
                            dashboardChrome
                            placeholder={t("register.home.platform.choose")}
                            aria-label={t("register.home.platform.prompt")}
                            value={shopPlatform}
                            onChange={(e) => {
                                setTouchedCustom(true);
                                setShopPlatform(e.target.value);
                            }}
                            errorText={!shopPlatform && touchedCustom ? t("register.home.platform.required") : undefined}
                            options={[
                                { label: t("register.home.platform.shopify"), value: 'shopify' },
                                { label: t("register.home.platform.woocommerce"), value: 'woocommerce' },
                            ]}
                        />
                    </Grid>
                {
                    shopPlatform && shopPlatform === "shopify" && <Grid item xs={12}>
                    <Formik
                        innerRef={formikRef}
                        key={defaultURL || ""}
                        initialValues={{
                            website_url: defaultURL || "",
                        }}
                        onSubmit={(values: any, formikHelpers) => {
                            formikHelpers.setSubmitting(true)
                            setError("");
                            loggedInUser ? localStorage.setItem('logged_in', 'true') : localStorage.setItem('logged_in', 'false')
                            let domain = values.website_url;
                            try {
                                domain = values.website_url.replace(/^https?:\/\//, '').replace(/\/\s*$/, "");;
                            } catch (e) {

                            }
                            const shop = {
                                domain,
                                shopPlatform
                            }
                            localStorage.setItem('shop', JSON.stringify(shop))
                            new OnBoardingApis().register_form(domain, shopPlatform, "", "", "")
                                .then((r) => {
                                    if (isMounted.current) {
                                        if (OnBoardingApis.hasError(r, notificationContext)
                                            || (!r.redirectURL && !r.shop && !r.reactURL)) {
                                            setLoading(false);
                                            formikHelpers.setSubmitting(false)
                                            if (!HandleErrors(r, formikHelpers)) {
                                                setError(r.message || "");
                                            }
                                        } else if (r.shop) {
                                            setLoading(false);
                                            formikHelpers.setSubmitting(false)
                                            dispatch({
                                                type: "set_active_shop",
                                                shop: r.shop
                                            })
                                            history.push({pathname: "/"});
                                        } else if (r.redirectURL) {
                                            window.location.href = r.redirectURL;
                                        } else if (r.reactURL) {
                                            history.replace(r.reactURL);
                                        }
                                    }
                                });
                        }}
                        validationSchema={urlRegisterSchema}
                    >
                        {({
                            handleSubmit,
                            handleChange,
                            values,
                            isSubmitting,
                        }: any) => (
                            <RegisterConnectOptions
                                platform="shopify"
                                copy={{
                                    connectPrompt: t("register.home.connectPrompt"),
                                    appStoreTitle: t("register.home.shopifyAppStoreTitle"),
                                    appStoreSubtitle: t("register.home.shopifyAppStoreSubtitle"),
                                    urlLabel: t("register.home.shopifyUrlLabel"),
                                    urlPlaceholder: t("register.home.urlPlaceholder"),
                                    getStarted: t("register.home.getStarted"),
                                    orLabel: t("register.home.orLabel"),
                                }}
                                formik={{
                                    handleSubmit,
                                    handleChange,
                                    values,
                                    isSubmitting,
                                }}
                                registerCardChildClass={classes.registerCardChild}
                                loginFormGroupClass={classes.loginFormGroup}
                                submitClass={classes.submit}
                            />
                        )}
                    </Formik>
                </Grid>
                }
                {
                    shopPlatform && shopPlatform === "woocommerce" && <Grid item xs={12}>
                        <Formik
                            innerRef={formikRef}
                            key={defaultURL || ""}
                            initialValues={{
                                website_url: defaultURL || "",
                            }}
                            onSubmit={(values: any, formikHelpers) => {
                                // woocommerce;
                                loggedInUser ? localStorage.setItem('logged_in', 'true') : localStorage.setItem('logged_in', 'false')
                                formikHelpers.setSubmitting(true)
                                setError("");
                                let domain = values.website_url;
                                try {
                                    domain = values.website_url.replace(/^https?:\/\//, '').replace(/\/\s*$/, "");;
                                } catch (e) {

                                }
                                new OnBoardingApis().register_woocommerce_form(domain, shopPlatform, "", "", "")
                                    .then((r) => {
                                        window.location.href = `https://${r}`
                                    });
                            }}
                            validationSchema={urlRegisterSchema}
                        >
                            {({
                                handleSubmit,
                                handleChange,
                                values,
                                isSubmitting,
                            }: any) => (
                                <RegisterConnectOptions
                                    platform="woocommerce"
                                    copy={{
                                        connectPrompt: t("register.home.connectPrompt"),
                                        appStoreTitle: t("register.home.woocommercePluginTitle"),
                                        appStoreSubtitle: t("register.home.woocommercePluginSubtitle"),
                                        urlLabel: t("register.home.wordpressUrlLabel"),
                                        urlPlaceholder: t("register.home.urlPlaceholder"),
                                        getStarted: t("register.home.getStarted"),
                                        orLabel: t("register.home.orLabel"),
                                    }}
                                    formik={{
                                        handleSubmit,
                                        handleChange,
                                        values,
                                        isSubmitting,
                                    }}
                                    registerCardChildClass={classes.registerCardChild}
                                    loginFormGroupClass={classes.loginFormGroup}
                                    submitClass={classes.submit}
                                />
                            )}
                        </Formik>
                    </Grid>
                }
                    {/* check if user is login */}
                    {loggedInUser ?
                            // <BootstrapAlert variant="success">Connect shop to your account.</BootstrapAlert>
                        null
                    :

                    <Grid item className="mt-3 register-layer-mobile__login-link">
                        {t("forgot.messages.haveAccount")}{" "}
                        <MuiLink component={RouterLink} to="/login" variant="body2">
                            {t("forgot.messages.loginNow")}
                        </MuiLink>
                    </Grid>
                    } 
                </Grid>
            {/* } */}
        </Grid>
    </DashboardLayer>
    </>;

}

export default RegisterHome;
